<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <HelpFiledStep2
      text="2. Полное наименование проекта"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_NAME']"
    />
    <uf_name />

    <HelpFiledStep2
      text="3. Программа финансовой поддержки"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_SUPPORT_PROG_ID']"
    />
    <uf_support_prog_id />

    <template v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">
      <div class="content-title content-mb-14">
        4. Направление финансирования
      </div>
      <uf_direction_financing_id></uf_direction_financing_id>
    </template>

    <div class="content-title content-mb-14">
      <span>5</span>. В структуре владения уставным капиталом преобладающее
      участие имеет паевой инвестиционный фонд
    </div>
    <uf_is_prevails_mutual_invest_fund></uf_is_prevails_mutual_invest_fund>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">6</span>
      <span v-else>5</span>. Требуемый объем финансирования со стороны Фонда,
      тыс. руб.
    </div>
    <uf_sum_request></uf_sum_request>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">7</span>
      <span v-else>6</span>. Сроки возврата займа, мес.
    </div>
    <uf_month_return></uf_month_return>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">8</span>
      <span v-else>7</span>. Отрасль промышленности
    </div>
    <uf_industry_id></uf_industry_id>

    <template v-if="project.UF_SETTING.IS_MOB_BUILDING_STRUCTURES != 1">
      <div class="content-title content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">9</span>
        <span v-else>8</span>.
        <template v-if="project.UF_SETTING.IS_NEW_NAME_NOMENCLATURE == 1"
          >Номенклатура продукции проекта
        </template>
        <template v-else>Номенклатура производимой продукции</template>
      </div>
      <ProvidingMobilizationNeeds :project="project">
      </ProvidingMobilizationNeeds>
    </template>

    <div class="content-title content-mb-14">
      <span
        v-if="
          $parent.project.UF_DIRECTION_FINANCING_ID > 0 &&
            project.UF_SETTING.IS_MOB_BUILDING_STRUCTURES == 1
        "
        >9</span
      >
      <span v-else-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">10</span>
      <span v-else>9</span>. Аннотация проекта
    </div>
    <uf_annotation></uf_annotation>

    <div class="content-title content-mb-14">
      <span
        v-if="
          $parent.project.UF_DIRECTION_FINANCING_ID > 0 &&
            project.UF_SETTING.IS_MOB_BUILDING_STRUCTURES == 1
        "
        >10</span
      >
      <span v-else-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">11</span>
      <span v-else>10</span>. Место реализации проекта
    </div>
    <place></place>

    <div class="content-title content-mb-14">
      <span style="float:left;">
        <span
          v-if="
            $parent.project.UF_DIRECTION_FINANCING_ID > 0 &&
              project.UF_SETTING.IS_MOB_BUILDING_STRUCTURES == 1
          "
          >11</span
        >
        <span v-else-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0"
          >12</span
        >
        <span v-else>11</span>. Продукция производится на спецтерритории</span
      >
      <span style="float: left;margin-top: 12px;margin-left: 10px;">
        <label class="switch">
          <input type="checkbox" v-model="project.UF_IS_PRODACTION_SP_TERR" />
          <span class="slider round"></span>
        </label>
      </span>
    </div>
    <SpecialPlace v-if="project.UF_IS_PRODACTION_SP_TERR"></SpecialPlace>

    <template v-if="project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">
      <div class="content-title content-mb-14">
        <span
          v-if="
            $parent.project.UF_DIRECTION_FINANCING_ID > 0 &&
              project.UF_SETTING.IS_MOB_BUILDING_STRUCTURES == 1
          "
          >12</span
        >
        <span v-else-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0"
          >13</span
        >
        <span v-else>12</span>. Финансовые показатели организации
      </div>
      <financialIndicator></financialIndicator>
    </template>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import VueTagsInput from "@johmun/vue-tags-input";
import { AUTH_URL } from "@/common/config";
import Vue from "vue";
import SystemIntegrator from "@/components/project/form/partial/SystemIntegrator";
import Digital_solution from "@/components/project/form/partial/DigitalSolution";
import System_equipment from "@/components/project/form/partial/SystemEquipment";
import Uf_name from "@/components/project/form/partial/uf_name";
import Uf_support_prog_id from "@/components/project/form/partial/uf_support_prog_id";
import Uf_sum_request from "@/components/project/form/partial/uf_sum_request";
import Uf_month_return from "@/components/project/form/partial/uf_month_return";
import Uf_industry_id from "@/components/project/form/partial/uf_industry_id";
import Uf_sub_industry_id from "@/components/project/form/partial/uf_sub_industry_id";
import Uf_is_ndt from "@/components/project/form/partial/uf_is_ndt";
import Okpd from "@/components/project/form/partial/okpd";
import Uf_annotation from "@/components/project/form/partial/uf_annotation";
import Uf_available_results from "@/components/project/form/partial/uf_available_results";
import Place from "@/components/project/form/partial/place";
import Subcontractors from "@/components/project/form/partial/subcontractors";
import Import_plan from "@/components/project/form/partial/import_plan";
import Uf_result_natural from "@/components/project/form/partial/uf_result_natural";
import Target_years from "@/components/project/form/partial/target_years";
import Export_countries from "@/components/project/form/partial/export_countries";
import Uf_is_reg_fond_help from "@/components/project/form/partial/uf_is_reg_fond_help";
import PromProducts from "@/components/project/form/partial/PromProducts";
import HighTechList from "@/components/project/form/partial/HighTechList";
import SpecialPlace from "@/components/project/form/partial/SpecialPlace";
import ProvidingMobilizationNeeds from "@/components/project/form/partial/ProvidingMobilizationNeeds";
import financialIndicator from "@/components/project/form/partial/FinancialIndicator";
import Uf_direction_financing_id from "@/components/project/form/partial/uf_direction_financing_id";
import HelpFiledStep2 from "@/components/project/form/subpartial/HelpFiledStep2.vue";
import uf_is_prevails_mutual_invest_fund from "@/components/project/form/partial/uf_is_prevails_mutual_invest_fund";

export default {
  name: "step2",
  props: ["step", "project"],
  components: {
    SpecialPlace,
    HighTechList,
    PromProducts,
    Uf_is_reg_fond_help,
    Export_countries,
    Target_years,
    Uf_result_natural,
    Import_plan,
    Subcontractors,
    Place,
    Uf_available_results,
    Uf_annotation,
    Okpd,
    Uf_sub_industry_id,
    Uf_industry_id,
    Uf_month_return,
    Uf_sum_request,
    Uf_support_prog_id,
    Uf_name,
    Uf_is_ndt,
    Uf_direction_financing_id,
    System_equipment,
    Digital_solution,
    SystemIntegrator,
    ProvidingMobilizationNeeds,
    financialIndicator,
    uf_is_prevails_mutual_invest_fund,
    VueTagsInput,
    HelpFiledStep2
  },
  data() {
    return {
      selectedTags: [],
      h4tooltip:
        "Успешная реализация Вашего проекта важна для региона. Если Вы хотите предоставить Региональному фонду доступ к текущей заявке, получить консультационную поддержку и помощь, выберите «Да» в выпадающем списке:",
      hCoExecutorTooltip:
        "Заполнение данного поля позволит Вам ускорить процедуру проведения акцептов платежей после получения средств займа.",
      h14tooltipShow: false,
      h14tooltip:
        "<img src='https://lkbe.frprf.ru/images/project/p13_info.png' />",
      siteUrl: "",
      tag: "",
      tags: [],
      RESULT_INTELLECTUAL_ACTIVITY: false,
      h18tooltip:
        'Ставка по предоставляемому целевому займу может быть изменена Фондом на 1% годовых,  если  выполнено требование п.7.3 Стандарта "Цифровизация промышленности"',
      h15tooltip:
        "Для возможного применения ставки 1 (один) процент годовых к займам, финансируемым по\n" +
        "                                программе «Цифровизация промышленности», Системный интегратор цифровых и\n" +
        "                                технологических\n" +
        "                                решений (далее - Системный интегратор), привлеченный в качестве Ключевого\n" +
        "                                исполнителя\n" +
        "                                (Одобренный ФРП при принятии решения о предоставлении займа) по проекту, должен\n" +
        "                                соответствовать следующим критериям:<br/>\n" +
        "                                1. являться резидентом РФ (определяется в соответствии с законодательством о валютном регулировании и валютном контроле);<br/>\n" +
        "                                2. не являться дочерним хозяйственным обществом (определяется в соответствии с ч. 1 ст. 67.3 ГК РФ) юридических лиц, созданных в соответствии с законодательством иностранных государств;<br/>\n" +
        "                                3. не находиться  процессе ликвидации или банкротства;<br/>\n" +
        "                                4. выплаты Заемщика по договорам/контрактам, заключенным с Системным интегратором в ходе реализации проекта составляют более 50% от суммы займа;<br/>\n" +
        "                                5. должен быть включен в один из рейтингов (применению подлежит актуальный рейтинг на последнюю отчетную дату и учитывается включение ключевого исполнителя в последнюю версию рейтинга российских ИТ-компаний), публикующихся на следующих информационных ресурсах:<br/>\n" +
        '                                • Раздел "ИТ-консалтинг (разработка и системная интеграция)" рэнкинга "Список крупнейших российских консалтинговых групп и компаний" Эксперт-РА (https://raex-a.ru/);<br/>\n' +
        "                                • Крупнейшие ИТ-компании России Cnews (www.cnews.ru);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Tadviser (www.tadviser.ru)."
    };
  },
  created() {
    this.siteUrl = AUTH_URL;
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "tree/industry",
      "code_okpd",
      "regions",
      "sp_monogorod",
      "list_import_plan",
      "product_plan_import",
      "start_pokazatel",
      "tree/vid_prom_products",
      "high_tehnology_sp",
      "sp_ndt",
      "sp_direction_financing"
    ]);

    if (this.project.SUBCONTRACTORS.length === 0) {
      //this.project.SUBCONTRACTORS.push({});
    }

    if (this.project.INDICATORS.items.length === 0) {
      this.project.INDICATORS.items = new Object();
    }

    let m = this;
    this.project.INDICATORS.INDICATORS_ID.forEach(function(indicator) {
      if (typeof m.project.INDICATORS.items[indicator] === "undefined") {
        Vue.set(m.project.INDICATORS.items, indicator, []);
      }
      for (
        let year = m.project.INDICATORS.yearStart;
        year <= m.project.INDICATORS.yearEnd;
        year++
      ) {
        let t = m.project.INDICATORS.items[indicator].filter(
          c => c.UF_INDICATORS_YEAR === year
        );
        if (t.length === 0) {
          m.project.INDICATORS.items[indicator].push({
            UF_INDICATORS_VALUE: 0,
            UF_INDICATORS_YEAR: year,
            UF_INDICATORS_ID: indicator
          });
        }
      }
    });

    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"])
      .then(() => {}, this);

    this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_project_products_mobilization_list"])
      .then(() => {}, this);
  },
  methods: {
    getInfoproductionId(code) {
      let t = this.directory.tree_sp_infoproduction.filter(
        c => c.CODE === code
      );
      if (t.length > 0 && t[0].URL !== null) {
        return t[0].ID;
      }
      return "";
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID === id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    }
  },
  computed: {
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
